import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {formatCurrency} from '@/utilities/helpers'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {DashboardEconomicSearchParams} from '../../types'
import {useGetDashboardAnalytics} from '../../query/useGetDashboardAnalytics'
import {useMemo} from 'react'
import {DashboardSimpleCardSkeleton} from '../dashboard-simple-card-skeleton/DashboardSimpleCardSkeleton'
import {calculateFirstMargin, calculateOperatingMargin} from '../../utils'

export const DashboardOperatingMarginCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(DashboardEconomicSearchParams)
    const {data, isLoading} = useGetDashboardAnalytics({
        fields: ['billedAccesses', 'costs', 'otherCosts'],
        ...searchParams
    })
    const firstMargin = useMemo(() => {
        return calculateFirstMargin(data?.billedAccesses?.accesses, data?.costs?.total)
    }, [data?.billedAccesses?.accesses, data?.costs?.total])
    const operatingMargin = useMemo(() => {
        return calculateOperatingMargin(firstMargin, data?.otherCosts?.total)
    }, [firstMargin, data?.otherCosts?.total])

    if (isLoading) {
        return <DashboardSimpleCardSkeleton title={t('dashboard:operating_margin')} />
    }

    return (
        <DashboardCard title={t('dashboard:operating_margin')}>
            <Text palette="neutral" shade="900" size="textXl" weight={700}>
                {formatCurrency(operatingMargin)}
            </Text>
        </DashboardCard>
    )
}
